import classNames from "classnames";
import type { CSSProperties } from "react";

import styles from "./CheckboxInput.module.scss";

interface CheckboxInputProps {
  id: string;
  value: boolean;
  label?: string;
  readonly?: boolean;
  /** Inherited CSS (padding, width, etc.) */
  textStyle?: CSSProperties;
  onChange: (value: boolean) => void;
}

export function CheckboxInput({
  id,
  value,
  label,
  readonly,
  textStyle,
  onChange,
}: CheckboxInputProps) {
  const inlineStyle: CSSProperties = {
    ...textStyle,
  };

  return (
    <div className={styles.container} style={inlineStyle}>
      <button
        type="button"
        id={id}
        className={classNames(styles.checkbox, value && styles.checked)}
        disabled={readonly}
        onClick={() => onChange(!value)}
        aria-checked={value}
        role="checkbox">
        {value && (
          <svg
            className={styles.checkmark}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        )}
      </button>
      {label && (
        <label htmlFor={id} className={styles.label}>
          {label}
        </label>
      )}
    </div>
  );
}
